<template>
	<div class="main">
		<!-- 头部 -->
    <Header :index="2"></Header>
		<!-- 面包屑导航 -->
		<div class="sec_top_position">
			<div class="curPosition">
				<img src="@/assets/img/fruit-transfer/icon14.png">
				您所在的位置：<a :href="homeHref">首页</a> &gt;
				<a href="#">互动交流</a>
			</div>
		</div>
		<div class="rightTop">
			<div class="content">
				<i class="el-icon-s-comment"></i>
				<span>互动交流</span>
			</div>
			<div class="searchbox">
				<el-input placeholder="请输入互动交流名称" v-model="pageParam.title" class="searchInput">
				</el-input>
		
				<div class="searchIcon" @click="keySearch()"><i class="el-icon-search"></i></div>
			</div>
		</div>
		<el-row :gutter="10" style="width: 16rem;margin: 0.1rem auto;">
			<el-col :span="5">
				<!-- <div class="rightTop">
					<div class="content">
						<i class="el-icon-s-comment"></i>
						<span>互动交流</span>
					</div>
				</div> -->

				<div class="imgbtn">
					<el-tooltip content="咨询建议" placement="bottom" effect="light">
						<a :href="consultLetterUrl">
							<img
									src="@/assets/img/interact/consult.png"
									fit="fill" >
							</img>
						</a>
					</el-tooltip>
				</div>
				<div class="imgbtn">
					<el-tooltip content="问题诉求" placement="bottom" effect="light">
						<a :href="problemLetterUrl">
							<img
									src="@/assets/img/interact/propose.png"
									fit="fill">
							</img>
						</a>
					</el-tooltip>
				</div>
				<div class="imgbtn">
					<el-tooltip content="信息报送" placement="bottom" effect="light">
						<a :href="infomationLetterUrl">
							<img
									src="@/assets/img/interact/search.png"
									fit="fill">
							</img>
						</a>
					</el-tooltip>
				</div>
			</el-col>
			<el-col :span="19">
				
				<div class="tableList">
					<el-timeline>
						<el-timeline-item
							class="timeItem"
							v-for="(item, index) in tableData"
							:key="index"
							color="#157ED6"
							:hide-timestamp="true"
							:timestamp="item.submitTime">
							<a class="listItem" @click.prevent="toDetail(item)">
								<div class="title">{{item.title}}</div>
								<div class="time">发布时间：{{ item.submitTime | dateFormat("YYYY-MM-DD") }}</div>
							</a>

						</el-timeline-item>
					</el-timeline>
					<div class="row-r">
						<el-pagination
								small
								layout="slot"
								:total="pageParam.pageTotal"
								:current-page="pageParam.page"
								:page-size="pageParam.pageSize"
								:page-sizes="[5, 10, 20, 50, 100]"
								@size-change="handleSizeChange"
								@current-change="handleCurrentChange">
							<span class="el-pagination__total">跳转至第<el-input v-model="pageValue" style="width:36px;" @change="jumper"></el-input>页</span>
						</el-pagination>
						<el-pagination
								small
								layout="slot"
								:total="pageParam.pageTotal"
								:current-page="pageParam.page"
								:page-size="pageParam.pageSize"
								:page-sizes="[5, 10, 20, 50, 100]"
								@size-change="handleSizeChange"
								@current-change="handleCurrentChange">
							<button :disabled="pageParam.page == pageParam.pageTotal" @click="toLastPage" style="cursor:pointer;margin-left: -11px;">尾页</button>
						</el-pagination>
						<el-pagination
								small
								layout="total,slot,prev,next"
								prev-text="上页"
								next-text="下页"
								@prev-click="prevClick"
								@next-click="nextClick"
								:total="pageParam.pageTotal"
								:current-page="pageParam.page"
								:page-size="pageParam.pageSize"
								:page-sizes="[5, 10, 20, 50, 100]"
								@size-change="handleSizeChange"
								@current-change="handleCurrentChange">
							<span class="el-pagination__total">，每页10条，页次 {{ pageParam.page }} / {{ Math.ceil(pageParam.pageTotal/10) }} 页</span>
							<button :disabled="pageParam.page == 1" @click="toFirstPage" style="cursor:pointer;margin-left:-5px;">首页</button>
						</el-pagination>
					</div>
				</div>
			</el-col>
		</el-row>
		<Footer></Footer>
	</div>
</template>

<script>
	import setRemPc from '@/api/setrem'
	import Header from '@/views/platform/components/header.vue'
	import Footer from '@/views/platform/components/footer.vue'
	import letterService from "@/api/platform-declare/letter";

	export default {
		components:{
			Header,
			Footer
		},
		data() {
			return {
				homeHref: process.env.VUE_APP_NAV_BASE_URL + 'ch00108/',
				// // 互动后端地址  chooseIcon:process.env.VUE_APP_COM_STATIC_BASE+'static/common/application/shenshu/css/img/choose5.png',
				consultLetterUrl:process.env.VUE_APP_COM_STATIC_BASE+"main/#/platform-declare-web/letter/advise/writeLetter?type=consult",
				problemLetterUrl:process.env.VUE_APP_COM_STATIC_BASE+"main/#/platform-declare-web/letter/advise/writeLetter?type=problem",
				infomationLetterUrl:process.env.VUE_APP_COM_STATIC_BASE+"main/#/platform-declare-web/letter/advise/myLetter?type=information",
				loading:false,//正在查询
				pageParam: {//查询条件
					page: 1,
					pageSize: 10,
					pageTotal: 0,//总条数
					title:''
				},
				tableData: [],
				pageValue:''
			};
		},
		mounted() {
			this.queryList();
		},
		created(){
			// 实例创建完成后被立即调用rem换算方法,解决内容闪现问题
			setRemPc();
			window.addEventListener('resize', setRemPc);//浏览器窗口大小改变时调用rem换算方法
		},
		methods: {
			goto(type){
				//http://localhost:9600/#/letter/consult/writeLetter
			},

			//每页数变化
			handleSizeChange(pageSize) {
				this.pageParam.page = 0;
				this.pageParam.pageSize = pageSize;
				this.queryList();
			},
			//页码变化
			handleCurrentChange(currentPage) {
				this.pageParam.page = currentPage;
				this.queryList();
			},
			//前往首页
			toFirstPage() {
				this.handleCurrentChange(1);
			},
			//  前往末页
			toLastPage() {
				let max = Math.ceil(this.pageParam.pageTotal / this.pageParam.pageSize);
				this.handleCurrentChange(max);
			},
			keySearch(){
				this.pageParam.page = 0;
				this.queryList();
			},
			//查询列表
			queryList() {
				this.loading = true;
				letterService.queryOpenLetter(this.pageParam).then(data => {
					this.tableData = data.data.list;
					this.pageParam.pageTotal = data.data.total;
					if(data.data.list.length === 0){
						this.$alert('抱歉，未能找到您想要的信息!', '192.168.15.45显示', {
							confirmButtonText: '确定'
						});
					}
				});
				this.loading = false;
			},
			toDetail(item){
				this.$router.push({path:"/platform/letter/detail",query:{letterId:item.id}})
			},
		}
	};
</script>

<style lang="scss" scoped>
	@import url('~@/assets/css/breadnav.css');
	.main{
		font-size: 0.17rem;
		padding: 0;
		margin: -8px;
		background-color: #F5F5F5;
	}
	.leftTop{
		height: 0.8rem;
		margin: 0.1rem 0 0 0.1rem;
		background-color: white;
		align-items: center;
		.content{
			width: 100%;
			height: 0.5rem;
			line-height: 0.5rem;
			font-size: 0.28rem;
			font-weight: 800;
			color:#157ED6;

			i{
				padding-left: 0.1rem;
				font-size: 0.3rem;
				margin-right: 0.05rem;
				margin-top: -0.03rem;
				vertical-align: middle;
			}
		}
	}
	.imgbtn{
		margin: 0.15rem 0;
		img{
			width: 100%;
		}
	}
	.rightTop{
		width: 15.85rem;
		margin: 0 auto;
		margin-top:0.25rem;
		display: flex;
		height: 0.8rem;
		background-color: white;
		align-items: center;
		box-sizing: border-box;
		padding-left: 0.47rem;
		.content{
			height: 0.5rem;
			line-height: 0.5rem;
			font-size: 0.24rem;
			font-weight: 500;
			color:#157ED6;
			i{
				padding-left: 0.1rem;
				font-size: 0.3rem;
				margin-right: 0.05rem;
				//margin-top: -0.03rem;
				vertical-align: middle;
			}
		}
		::v-deep .searchbox {
			margin: 0.02rem 0.1rem 0 auto;
			width: 2.55rem;
			height: 0.42rem;
			line-height: 0.42rem;
			position: relative;
			.searchInput {
				width: 100%;
				height: 0.42rem !important;
				display: block;

				.el-input__inner {
					width: 2.38rem;
					height: 0.45rem !important;
					padding-left: 0.2rem;
					outline: none;
					font-size: 0.177rem;
					background-color: transparent;
					border-radius: 0.21rem;
					border: 0.01rem solid #DCDFE6;
				}
			}
			.searchIcon {
				width: 0.46rem;
				height: 0.46rem;
				border-radius: 50%;
				-moz-border-radius: 50%;
				-webkit-border-radius: 50%;
				position: absolute;
				right: 0;
				top: -0.02rem;
				background-color: #1E8CE6;
				color:white;
				font-size: 0.177rem;
				text-align: center;
				cursor: pointer;
				i{
					font-size: 0.23rem;
					margin-top: 0.11rem;
				}
			}
		}
	}
	.tableList{
		margin-top: 0.15rem;
	}
	.el-timeline-item {
		padding-bottom: 0.2rem;
	}
	.listItem{
		display: flex;
		width: 100%;
		height: 0.4rem;
		line-height: 0.2rem;
		align-items: center;
		font-size: 0.177rem;
		border-bottom: 0.01rem dashed #cecece;
		cursor: pointer;
		.title{
			color:#2e2e2e;
		}
		.time{
			color:#9B9B9B;
			width:3rem;
			text-align: right;
			margin-left: auto;
		}

	}
	.listItem :hover{
		color:#ff0000;
	}
	::v-deep .el-pagination .btn-next, .el-pagination .btn-prev {
		 background: center center no-repeat #F5F5F5;
	}
	::v-deep .el-pagination button:disabled {
		background-color: #F5F5F5;
	}
	::v-deep .el-pager li {
		 background: #F5F5F5;
	}
	::v-deep  .el-pagination .el-select .el-input .el-input__inner {
		height: 22px !important;
		background-color: #F5F5F5;
		font-size: 13px;
	}
	::v-deep  .el-pagination__editor.el-input .el-input__inner {
		height: 22px !important;
		background-color: #F5F5F5;
	}
	::v-deep  .el-select .el-input .el-select__caret {
		line-height: 40px !important;
	}
	::v-deep .el-pagination .el-input__inner{
		border-radius: 0 0;
		height: 20px !important;
		background-color: #f5f5f5;
	}
</style>
<style>
	.el-pagination .btn-prev {
		padding-right: 0px;
		background-color: #F5F5F5;
	}
	.el-pagination .btn-next {
		padding-left: 0px;
		background-color: #F5F5F5;
	}
	.el-pagination--small button, .el-pagination--small span:not([class*=suffix]) {
		line-height: 30px;
	}
	.el-input__inner{
		padding:0 5px;
	}
	.el-message-box__wrapper::after {
		vertical-align: top;
		background-color: rgba(255,255,255,0);
	}
</style>
